import React from "react";
import { Divider, PageTitle } from "../../../../../../components";
import { dateFormator } from "../../../../../../utils";

const CardWrapper = ({ title, children, color }) => {
  return (
    <div
      className={`p-3 bg-${color}-100/10 rounded border-[1px] border-${color}-50`}
    >
      <div className="text-xs font-semibold text-black">{title}</div>
      {children}
    </div>
  );
};

const TableRowData = ({
  title,
  value,
  divider = null,
  titleStyle = "",
  dividerStyle = "",
  valueStyle = "",
}) => {
  return (
    <React.Fragment>
      <div className={`${titleStyle}`}>{title}</div>
      {divider && <div className={`${dividerStyle}`}>{divider}</div>}
      <div className={`${valueStyle}`}>{value}</div>
    </React.Fragment>
  );
};

const InvoiceContent = ({ data = {}, color = "primary", type = "top" }) => {
  console.log(data);

  return (
    <div>
      {type === "top" ? (
        <div className="content-top my-5 grid grid-cols-3 gap-3 p-3 inputShadow rounded-xl">
          <CardWrapper title="Invoice From:" color={color}>
            <h6 className="my-1">{data?.company?.name}</h6>
            <div className="text-xs leading-normal">
              <p>{data?.company?.address}</p>
              <p>{data?.company?.email}</p>
              <p>{data?.company?.contact}</p>
            </div>
          </CardWrapper>
          <CardWrapper title="Invoice To:" color={color}>
            <h6 className="my-1">{data?.invoiceDeta?.name}</h6>
            <div className="text-xs leading-normal">
              <p>{data?.invoiceDeta?.address}</p>
            </div>
          </CardWrapper>
          <CardWrapper title="Invoice Details:" color={color}>
            <div className="table-loop-data mt-2 grid grid-cols-[auto_auto_auto] gap-0.5 text-xs">
              <TableRowData
                title="Invoice Number"
                value={data?.invoiceDeta?.invoiceNumber}
                divider=":"
              />
              <TableRowData
                title="Invoice Date"
                value={dateFormator(data?.invoiceDeta?.invoiceDate, "short")}
                divider=":"
              />
              <TableRowData
                title="Shipped Date"
                value={dateFormator(data?.invoiceDeta?.shippedDate, "short")}
                divider=":"
              />
              <TableRowData
                title="Net Terms"
                value={data?.invoiceDeta?.netTerms}
                divider=":"
              />
              <TableRowData
                title="Due Date"
                value={dateFormator(data?.invoiceDeta?.dueDate, "short")}
                divider=":"
              />
            </div>
          </CardWrapper>
        </div>
      ) : (
        <div className="">
          <div className={`w-full flex justify-end`}>
            <div
              className={`text-xs border-[1px] border-${color}-100 flex flex-col gap-2 rounded overflow-hidden`}
            >
              <div className={`px-3 pt-2 col-span-2 grid grid-cols-2`}>
                <TableRowData
                  title="Sub Total"
                  value={`$ ${data?.invoiceDeta?.totalDue?.toFixed(2)}`}
                  valueStyle="text-right"
                />
              </div>
              <div className={`px-3 col-span-2 grid grid-cols-2`}>
                <TableRowData
                  title="Invoice Total"
                  value={`$ ${data?.invoiceDeta?.totalDue?.toFixed(2)}`}
                  valueStyle="text-right"
                />
              </div>
              <div
                className={`bg-${color} px-3 py-2 text-white col-span-2  grid grid-cols-2 gap-x-20`}
              >
                <TableRowData
                  title="Invoice Total"
                  value={`$ ${data?.invoiceDeta?.totalDue?.toFixed(2)}`}
                  valueStyle="text-right"
                />
              </div>
            </div>
          </div>
          <div
            className={`w-full max-w-72 p-2 border-[1px] border-${color}-100 mt-10 bg-white/50 rounded`}
          >
            <div className={`text-${color} font-semibold text-sm`}>
              Additional Info:
            </div>
            <Divider className="my-1" />
            <p className="text-xs leading-relaxed">
              {data?.company?.additionalInfo}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default InvoiceContent;
